<div
  #container
  class="flex w-full h-full relative"
  [ngClass]="{ 'transition-none': dragging }"
>
  <!-- Left pane -->
  <div
    class="overflow-hidden flex flex-col h-full w-full pr-2 pb-1 min-w-0 transition-all duration-300 ease-in-out"
    [ngClass]="{
      'w-0 opacity-0': collapsed() === 'left',
    }"
    [ngStyle]="{
      'flex-basis': leftPaneWidth() + '%',
    }"
    (transitionend)="onResizeTransitionEnd($event)"
  >
    <ng-content class="flex flex-col h-full" select="[leftPane]"></ng-content>
  </div>

  <!-- Splitter -->
  <div class="w-[2px]"></div>
  <div
    [ngClass]="{
      'bg-gray-600 cursor-col-resize': dragEnabled && collapsed() === 'none',
    }"
    class="w-[2px] h-full absolute z-10 transition-all duration-300 ease-in-out"
    [ngStyle]="{ left: leftPaneWidth() + '%' }"
    (mousedown)="startDragging($event)"
  ></div>

  <!-- Right pane -->
  <div
    class="overflow-hidden flex flex-col h-full pl-2 pb-1 transition-all duration-300 ease-in-out"
    [ngClass]="{
      'w-0 opacity-0': collapsed() === 'right',
    }"
    [ngStyle]="{
      'flex-basis': rightPaneWidth() + '%',
    }"
  >
    <ng-content class="flex flex-col h-full" select="[rightPane]"></ng-content>
  </div>

  @if (collapsable) {
    @if (collapsed() !== 'left') {
      <button
        (click)="toggleCollapse('left')"
        class="!z-50 theme-bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center absolute transform transition-all duration-300 ease-in-out"
        [ngClass]="{
          'opacity-0 scale-0': buttonAnimating,
          'animate-fade-in': !buttonAnimating,
        }"
        [ngStyle]="{
          top: leftHeight,
          left:
            collapsed() === 'none'
              ? 'calc(' + leftPaneWidth() + '% - 20px)'
              : 'calc(' + leftPaneWidth() + '% - 40px)',
        }"
        [matTooltip]="
          escapeCollapseDirection === 'left'
            ? 'Collapse left panel (Shift+Esc)'
            : 'Collapse left panel'
        "
        matTooltipPosition="above"
      >
        <span class="inline-block">&larr;</span>
      </button>
    }
    @if (collapsed() !== 'right') {
      <button
        (click)="toggleCollapse('right')"
        class="!z-50 theme-bg-primary text-white rounded-full w-10 h-10 flex items-center justify-center absolute transform transition-all duration-300 ease-in-out"
        [ngClass]="{
          'opacity-0 scale-0': buttonAnimating,
          'animate-fade-in': !buttonAnimating,
        }"
        [ngStyle]="{
          top: collapsed() === 'left' ? leftHeight : rightHeight,
          left:
            collapsed() === 'none'
              ? 'calc(' + leftPaneWidth() + '% - 20px)'
              : '0px',
        }"
        [matTooltip]="
          escapeCollapseDirection === 'right'
            ? 'Collapse right panel (Shift+Esc)'
            : 'Collapse right panel'
        "
        matTooltipPosition="above"
      >
        <span class="inline-block">&rarr;</span>
      </button>
    }
  }
</div>
